import React from 'react';

const Help = () => {
  return (
    <div className="container mt-5">
      <h1 className="text-center mb-4">Help & Support</h1>
      <div className="row">
        <div className="col-md-8 mx-auto">
          <div className="card">
            <div className="card-body">
              <h5>Frequently Asked Questions</h5>
              <p>Find answers to common questions about our services.</p>
              <h5>Contact Support</h5>
              <p>Need assistance? Reach out to our support team for help.</p>
              <h5>User Guide</h5>
              <p>Learn how to use our platform with our comprehensive guide.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Help;